export { default as CountdownTimer } from './CountdownTimer.vue';
